import { CHIPS_COLORS } from './colors';
import { ChipType } from '../types';
import { CHIP_1M_PURPLE, chipsMIN2k } from './chipsValues';

export const CHIPS_MIN_2k: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 500,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 2e3,
  },
  ...chipsMIN2k,
  CHIP_1M_PURPLE,
];

export const CHIPS_MIN_2k_v2: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 500,
  },
  {
    color: CHIPS_COLORS.BLUE,
    value: 2e3,
  },
  ...chipsMIN2k,
];
